module.exports = __webpack_public_path__ + "img/hint.19e830d0.svg";